const claimStatuses = {
	PENDING_DECISION: "PENDING_DECISION",
	SETTLED_IN_FULL: "SETTLED_IN_FULL",
	IN_REPAIR: "IN_REPAIR",
	REPAIRED: "REPAIRED",
	FILE_CLOSED_REJECTION: "FILE_CLOSED_REJECTION",
	FILE_CLOSED_ACCEPTED: "FILE_CLOSED_ACCEPTED",
	IN_PROGRESS: "IN_PROGRESS",
	IN_DISPUTE: "IN_DISPUTE",
	IN_ARBITRATION: "IN_ARBITRATION",
	EX_GRATIA: "EX_GRATIA",
	QUOTE_ONLY: "QUOTE_ONLY",
};

export default claimStatuses;
